import store from '@/store'
import { UPDATE_PRODUCT_INFO } from '@/store/modules/productEdit.module'
import { productConstants } from '@kingpin-global/kingpin-utils-frontend'
import { computed, watch, ref } from '@vue/composition-api'

export const useBasicInfo = () => {
  const styleCode = computed({
    get() {
      return store.state.productEdit.newData.styleCode
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'styleCode', newValue: value })
    },
  })
  const uniqueId = computed({
    get() {
      return store.state.productEdit.newData.uniqueId
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'uniqueId', newValue: value })
    },
  })
  const name = computed({
    get() {
      return store.state.productEdit.newData.name
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'name', newValue: value })
    },
  })
  const descriptionLong = computed({
    get() {
      return store.state.productEdit.newData.descriptionLong
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'descriptionLong', newValue: value })
    },
  })
  const descriptionMaterials = computed({
    get() {
      return store.state.productEdit.newData.descriptionMaterials
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'descriptionMaterials', newValue: value })
    },
  })
  const status = computed({
    get() {
      return store.state.productEdit.newData.status
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'status', newValue: value })
    },
  })
  const isLive = computed({
    get() {
      const currentStatus = store.state.productEdit.newData.status
      return currentStatus?.[0]?.toLowerCase() !== 'draft'
    },
    set(value) {
      const newStatus = value ? ['live'] : ['draft']
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'status', newValue: newStatus })
    },
  })
  const gender = computed({
    get() {
      return store.state.productEdit.newData.gender
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'gender', newValue: value })
    },
  })
  const department = computed({
    get() {
      return store.state.productEdit.newData.department
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'department', newValue: value })
    },
  })
  const category = computed({
    get() {
      return store.state.productEdit.newData.category
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'category', newValue: value })
    },
  })
  const subCategory = computed({
    get() {
      return store.state.productEdit.newData.subCategory
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'subCategory', newValue: value })
    },
  })

  const subCategoryOptions = ref([
    {
      title: '',
      options: [],
    },
  ])

  watch(category, newVal => {
    let newOptions = []

    if (newVal && newVal.length) {
      newOptions = productConstants.SUB_CATEGORIES[newVal[0]] || []
    }
    subCategoryOptions.value = [
      {
        title: '',
        options: newOptions,
      },
    ]
  })

  return {
    styleCode,
    uniqueId,
    name,
    descriptionLong,
    descriptionMaterials,
    status,
    isLive,
    gender,
    department,
    category,
    subCategory,
    subCategoryOptions,
  }
}
